'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'plane';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f072';
var svgPathData = ['M44.5 144l27 108.1 1 3.9-1 3.9L44.5 368 80 368l43.2-57.6L128 304l8 0 74.3 0 21.2 0-5.8 20.4L181.2 480l65.5 0 96-167.9 4.6-8.1 9.3 0 109.7 0c13.6 0 34.2-5.9 51.4-16.2C535.8 276.9 544 265.1 544 256c0-4.1-1.7-9-6.3-14.8c-4.6-5.8-11.5-11.5-20-16.7c-17.3-10.5-37.9-16.6-51.3-16.6l-109.7 0-9.3 0-4.6-8.1L246.7 32l-65.5 0 44.5 155.6 5.8 20.4-21.2 0L136 208l-8 0-4.8-6.4L80 144l-35.5 0z', 'M562.7 221.2c7.6 9.5 13.3 21.3 13.3 34.8c0 26.9-21.6 47.1-41.8 59.2c-21.1 12.7-47.3 20.8-67.9 20.8l-100.5 0-96 167.9-4.6 8.1-9.3 0-96 0-21.2 0 5.8-20.4L189.1 336 144 336l-43.2 57.6L96 400l-8 0-64 0L3.5 400l5-19.9L39.5 256 8.5 131.9 3.5 112 24 112l64 0 8 0 4.8 6.4L144 176l45.1 0L144.6 20.4 138.8 0 160 0l96 0 9.3 0 4.6 8.1 96 167.9 100.5 0c20.7 0 46.9 8.4 68 21.2c10.7 6.5 20.8 14.5 28.4 24zm-45 3.3c-17.3-10.5-37.9-16.6-51.3-16.6l-109.7 0-9.3 0-4.6-8.1L246.7 32l-65.5 0 44.5 155.6 5.8 20.4-21.2 0L136 208l-8 0-4.8-6.4L80 144l-35.5 0 27 108.1 1 3.9-1 3.9L44.5 368 80 368l43.2-57.6L128 304l8 0 74.3 0 21.2 0-5.8 20.4L181.2 480l65.5 0 96-167.9 4.6-8.1 9.3 0 109.7 0c13.6 0 34.2-5.9 51.4-16.2C535.8 276.9 544 265.1 544 256c0-4.1-1.7-9-6.3-14.8c-4.6-5.8-11.5-11.5-20-16.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlane = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;